/**
 * ============================================================
 * 公交车配置
 * ============================================================
 * PC 和移动端共用此配置
 *
 * 所有数值基于设计稿坐标（1920×1080），运行时自动乘以 scaleRatio
 *
 * designLeft    - 公交车初始出现的横向位置（第一屏右侧）
 * designTop     - 公交车纵向位置（路面高度）
 * designHeight  - 公交车高度
 * stickyScreenX - 固定到屏幕左侧的位置（模拟"坐公交"看风景）
 * src           - 公交车 GIF 图片路径
 * zIndex        - 层级（前景后面，中景前面）
 */
export default {
  src: "./xiangan/gif/公车.gif",
  designLeft: 1700,
  designTop: 630,
  designHeight: 532,
  stickyScreenX: -800,
  zIndex: 8,
};

